import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PROGRAMS } from '../data/schoolData';
import m1 from '../images/m1.jpg';
import school from '../images/school.jpg';
export default function HomePage({ onNav }) {
  const navigate = useNavigate();

  return (
    <>
      {/* Hero */}
      <section className="hero">
        <div className="hero-bg"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">Nurturing Young Minds</div>
            <h2>Building Strong<br/>Foundations for<br/><span>Bright</span> Futures</h2>
            <p>A safe, joyful and inspiring environment where every child learns, grows and shines.</p>
            <div className="hero-btns">
              <button className="btn-primary" onClick={() => onNav('about')}>About Our School</button>
              <button className="btn-outline" onClick={() => onNav('admissions')}>Admissions Open</button>
              <button className="btn-outline" onClick={() => navigate('/login')}>Login</button>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card"><div className="stat-icon blue">🎓</div><div><div className="stat-num">120+</div><div className="stat-label">Happy Students</div></div></div>
            <div className="stat-card"><div className="stat-icon green">👥</div><div><div className="stat-num">8+</div><div className="stat-label">Dedicated Teachers</div></div></div>
            <div className="stat-card"><div className="stat-icon purple">🏆</div><div><div className="stat-num">15+</div><div className="stat-label">Years of Excellence</div></div></div>
            <div className="stat-card"><div className="stat-icon red">🛡️</div><div><div className="stat-num">100%</div><div className="stat-label">Safe &amp; Secure</div></div></div>
          </div>
        </div>
      </section>

      {/* About snippet */}
      <section className="about">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <div className="section-tag">About Our School</div>
              <h2 className="section-title">A Place Where Learning Meets Happiness</h2>
              <p>Basaveshwar Pre-Primary School, Belur-Chikkanasabi is dedicated to providing quality early education in a loving and supportive environment. We focus on the all-round development of every child.</p>
              <ul className="about-list">
                <li>Play-way learning approach</li>
                <li>Safe and child-friendly campus</li>
                <li>Experienced and caring teachers</li>
                <li>Focus on character &amp; values</li>
              </ul>
              <button className="btn-primary" onClick={() => onNav('about')}>Know More About Us</button>
            </div>
            <div className="about-img-wrap">
              <img src={school} alt="School building"/>
              <div className="about-badge">
                <div className="about-badge-icon">🏫</div>
                <div className="about-badge-text">A Great Place<br/>To Learn &amp; Grow</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Programs */}
      <section className="programs">
        <div className="container">
          <div className="programs-header">
            <div className="section-tag">Our Programs</div>
            <h2 className="section-title">Learning Through Play, Growing Every Day</h2>
          </div>
          <div className="programs-grid">
            {PROGRAMS.map((p,i) => (
              <div className="program-card" key={i}>
                <div className={`prog-icon ${p.color}`}>{p.icon}</div>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Admissions CTA */}
      <section className="admissions">
        <div className="container">
          <div className="admissions-inner">
            <div className="admissions-text">
              <div className="section-tag">Admissions</div>
              <h2 className="section-title">Admissions Open<br/><span>2026-2027</span></h2>
              <p>Give your child the best start to a bright and successful future. Enrol now and be part of our growing family.</p>
              <button className="btn-primary" onClick={() => onNav('admissions')}>Apply Now →</button>
            </div>
            <div className="admissions-img">
              <img src={m1} alt="Happy students"/>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
